import React, { useState } from 'react';
import qs from 'qs';
import classNames from 'classnames';

import SearchFilters from './Filters';
import Search from './Search';

import { fridayStartDate } from '../../../config/constants';

import './style.scss';

const useInitialValues = () => {
  const initialValues = {};
  const parsed = qs.parse(window.location.search.slice(1), { arrayLimit: 99 });

  const filters = {
    full: true,
    highschool_availability: false,
  };

  if (parsed.filters) {
    parsed.filters.forEach((filter) => {
      switch (filter.identifier) {
        case 'type':
          filters['type'] = filter.value;
          break;

        case 'date':
          if (filter.min === fridayStartDate) {
            filters['date'] = '1';
          } else {
            filters['date'] = '2';
          }
          break;

        case 'availability':
          filters['availability'] = filter.min;
          break;

        case 'radius':
          filters['radius'] = (parseInt(filter.geoRadius.radius) / 1000).toString();
          filters['area'] = {
            lat: Number(filter.geoRadius.center.lat),
            lon: Number(filter.geoRadius.center.lon),
          };
          break;

        // Drupal\nldoet_search\Controller::MunicipalitySearch relies on these filters
        // if they ever change, change them there too.
        case 'area_name':
          filters['area_name'] = filter.value;
          break;

        case 'full':
          filters['full'] = filter.boolValue.toString() === 'true';
          break;

        case 'highschool_availability':
          filters['highschool_availability'] = filter.boolValue.toString() === 'true';
          break;

        case 'fake_box':
          break;

        default:
          console.log("FILTER", filter);
          break;
      }
    });
  }

  return { ...initialValues, ...filters };
};

const Filters = () => {
  const initialValues = useInitialValues();
  const [filtersVisible, setFiltersVisible] = useState(false);
  const filterClassName = classNames('Filters', filtersVisible ? 'filters-open' : '');

  return (
    <>
      <div className={filterClassName}>
        <Search initialValues={initialValues} />
        <SearchFilters
          initialValues={initialValues}
          filtersVisible={filtersVisible}
          setFiltersVisible={setFiltersVisible}
        />
      </div>
      <a className="mobileOrganisationLink" href="/resultaten-op-naam" target="_parent" rel="noreferrer">of zoek op organisatienaam</a>
    </>
  );
};

export default Filters;
